// The ring of yellow dots from the foot of every FXRY email and the dots in
// the logo, turning while the checkout loads. Identical dots spinning would
// look still, so they fade round the ring and it turns a dot at a time.
const DOTS = 8;

const Loader = () => {
  return (
    <div className="loading-screen" role="status" aria-label="Loading">
      <svg className="fx-loader" viewBox="0 0 48 48" aria-hidden="true">
        {Array.from({ length: DOTS }, (_, i) => {
          const angle = (i / DOTS) * 2 * Math.PI;
          return (
            <circle
              key={i}
              cx={24 + 18 * Math.sin(angle)}
              cy={24 - 18 * Math.cos(angle)}
              r="3.6"
              opacity={1 - i * 0.11}
            />
          );
        })}
      </svg>
    </div>
  );
};

export default Loader;
